import addPrecision from "../../common/addPrecision";
import numberFormat from "../../common/numberFormat";
import Table from "../../common/Table";
import LetterHeader from "../../components/LetterHeader";
import {
  salesHeader,
  rebatesHeader,
  salaryHeader,
  otherExpensesHeader,
  jobHeader,
  incomeList,
  paymentDues,
  salesHST,
} from "./StatementTables";
import moment from "moment";

const RebateStatementTemplate = ({
  duePaymentsList,
  form,
  saleSum,
  rebateSum,
  salarySum,
  otherExpensesSum,
  expensesSum,
  income,
  endDateBasedJobsData,
  salesIncome,
  duePayments,
  sales,
  organizations,
  rebates,
  salary,
  expenses,
  organizationsData,
  salesIncomeList,
}) => {
  return (
    <div style={{ padding: "0.5cm", backgroundColor: "#ffffff" }}>
      <div>
        <LetterHeader />
      </div>
      <div
        style={{
          height: "3px",
          width: "100%",
          backgroundColor: "black",
          margin: "10px 0px",
        }}
      ></div>
      <br />
      <br />
      <p style={{ textAlign: "center", fontWeight: "bold", fontSize: "16px" }}>
        Income Statement for the selected period from{" "}
        {moment(form.from).format("DD/MM/YYYY")} to{" "}
        {moment(form.to).format("DD/MM/YYYY")}
      </p>
      <br />
      <table
        className="table table-bordered"
        style={{ fontSize: 14, width: "100%" }}
      >
        <thead>
          <tr>
            <td colSpan={3}>
              <b>INCOMES</b>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Total Sales</td>
            <td>{`$ ${addPrecision(numberFormat(saleSum))}`}</td>
            <td></td>
          </tr>
          <tr>
            <td>Other Income</td>
            <td>{`$ ${addPrecision(numberFormat(rebateSum))}`}</td>
            <td></td>
          </tr>
          <tr>
            <td colSpan={2}>
              <b>GROSS INCOME</b>
            </td>

            <td>
              <b>{`$ ${addPrecision(numberFormat(income))}`}</b>
            </td>
          </tr>
        </tbody>

        <thead>
          <tr>
            <td colSpan={3}>
              <b>Cost of Sales</b>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Payroll</td>
            <td>{`$ ${addPrecision(numberFormat(salarySum))}`}</td>
            <td></td>
          </tr>
          <tr>
            <td>Other Expenses</td>
            <td>{`$ ${addPrecision(numberFormat(otherExpensesSum))}`}</td>
            <td></td>
          </tr>
          <tr>
            <td colSpan={2}>
              <b>TOTAL EXPANSES</b>
            </td>

            <td>
              <b>{`$ ${addPrecision(numberFormat(expensesSum))}`}</b>
            </td>
          </tr>
        </tbody>

        <thead>
          <tr>
            <td colSpan={2}>
              <b>NET PROFIT / LOSS</b>
            </td>
            <td>
              <b>{`$ ${addPrecision(numberFormat(income - expensesSum))}`}</b>
            </td>
          </tr>
        </thead>
      </table>
      <br />
      <div>
        <p>
          <b>Other Details</b>
        </p>
        <table className="table table-default" style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td>No of completed jobs for the selected time period:</td>
              <td>{endDateBasedJobsData?.length}</td>
            </tr>
            <tr>
              <td>Total sale's paid for given period (HST included):</td>
              <td>{`$ ${addPrecision(numberFormat(salesIncome))}`}</td>
            </tr>
            <tr>
              <td>Payment Dues:</td>
              <td>{`$ ${addPrecision(numberFormat(duePayments))}`}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/*  Sales List */}
      <div
        style={{
          pageBreakBefore: "always",
          paddingTop: "1cm",
        }}
      >
        <p
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          Sales List
        </p>
        <div>
          <Table
            normalTable
            header={salesHeader}
            data={sales?.map((i) => {
              return {
                ...i,
                organizationName: i.organization
                  ? organizations?.find((org) => i.organization === org._id)
                      ?.name
                  : i.contract?.organizationName,
                invoiceDate: moment(i.invoiceDate).format("DD/MM/YYYY"),
                total: i.subtotal
                  ? addPrecision(numberFormat(i.subtotal))
                  : addPrecision(numberFormat(i.price)),
              };
            })}
          />
        </div>
      </div>

      {/* Other Incomes */}
      <div
        style={{
          pageBreakBefore: "always",
          paddingTop: "1cm",
        }}
      >
        <p
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          Other Incomes List
        </p>
        <div>
          <Table
            normalTable
            header={rebatesHeader}
            data={rebates?.map((i) => {
              return {
                ...i,
                amount: addPrecision(numberFormat(i.amount)),
                date: moment(i.date).format("DD/MM/YYYY"),
              };
            })}
          />
        </div>
      </div>

      {/* Payroll */}
      <div
        style={{
          pageBreakBefore: "always",
          paddingTop: "1cm",
        }}
      >
        <p
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          Payroll List
        </p>
        <div>
          <Table
            header={salaryHeader}
            normalTable
            data={salary?.map((i) => {
              return {
                ...i,
                date: moment(i.date).format("DD/MM/YYYY"),
                amount: addPrecision(numberFormat(i.amount)),
              };
            })}
          />
        </div>
      </div>

      {/* Other Expenses */}
      <div
        style={{
          pageBreakBefore: "always",
          paddingTop: "1cm",
        }}
      >
        <p
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          Other Expenses List
        </p>
        <div>
          <Table
            header={otherExpensesHeader}
            normalTable
            data={expenses?.map((i) => {
              return {
                ...i,
                category: i.category?.category,
                date: moment(i.date).format("DD/MM/YYYY"),
                amount: addPrecision(numberFormat(i.amount)),
              };
            })}
          />
        </div>
      </div>

      {/* Completed Jobs */}
      <div
        style={{
          pageBreakBefore: "always",
          paddingTop: "1cm",
        }}
      >
        <p
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          Completed Jobs List
        </p>
        <div>
          <Table
            normalTable
            header={jobHeader}
            data={endDateBasedJobsData?.map((i) => {
              return {
                ...i,
                client:
                  organizationsData?.find((org) => org._id === i.organization)
                    ?.name || "",
                jobStartDate: moment(i.jobStartDate).format("DD/MM/YYYY"),
                jobEndDate: moment(i.jobEndDate).format("DD/MM/YYYY"),
              };
            })}
          />
        </div>
      </div>

      {/* Sales Paid */}
      <div
        style={{
          pageBreakBefore: "always",
          paddingTop: "1cm",
        }}
      >
        <p
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          Sales Paid List
        </p>
        <div>
          <Table
            normalTable
            header={incomeList}
            data={salesIncomeList?.map((i) => {
              return {
                ...i,
                invoiceDate: i.job
                  ? moment(i.job_obj?.invoiceDate).format("DD/MM/YYYY")
                  : moment(i.contractInvoice_obj?.createdAt).format(
                      "DD/MM/YYYY"
                    ),
                invoiceID: i.job
                  ? i.job_obj?.invoiceID
                  : i.contractInvoice_obj?.invoiceID,
              };
            })}
          />
        </div>
      </div>

      {/* Payment Dues Paid */}
      <div
        style={{
          pageBreakBefore: "always",
          paddingTop: "1cm",
        }}
      >
        <p
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          Payment Dues List
        </p>
        <div>
          <Table
            header={paymentDues}
            normalTable
            data={duePaymentsList?.map((due) => ({ ...due }))}
          />
        </div>
      </div>
    </div>
  );
};

export default RebateStatementTemplate;
